import axios from "axios";

export class Unsplash {
  constructor() {
    this.accessKey = 'Q8BxybWubZFMG8tsf07NRBKLn3oGRVwsnv4wiRHJSxc'
    this.collection = [];
  }

  build() {
    let urlUnsplash = `https://api.unsplash.com/photos/?client_id=${this.accessKey}`;
    return axios.get(urlUnsplash).then(response => {
        return response.data.map(item => {
          return { id: item.id, alt: item.alt_description, url: item.urls.small }
        })
      })
  }
}
